import React, { Component } from 'react';
import letters from './svg/font.json';
import { SvgGetPoints, FillInGaps, Normalize } from './HelpFunctions';

class TextWrite extends Component {
	svgToPoints(paths, xoffset, yoffset) {
		try {
			return SvgGetPoints(paths, xoffset, yoffset);
		} catch (e) {
			console.log("TextWrite Exception in", paths, e);
		}
		return undefined;
	}

	componentDidMount() {
		try {
			this.setState(JSON.parse(localStorage.getItem('TextWrite')));
		}
		catch { }
	}

	componentWillUnmount() {
		localStorage.setItem('TextWrite', JSON.stringify(this.state));
	}

	use() {
		let points = [];
		let xoffset = 0;
		let yoffset = 0;

		let ycoords = [];
		let xcoords = [];
		this.state.text.split("").forEach((letter) => {
			if (letter === "\n") {
				yoffset += 100;
				xoffset = 0;
			} else if (!letters[letter]) {
				xoffset += 50;
			} else {
				let d = letters[letter]["path"];
				if (d) {
					let paths = d.split('M').map((e) => {
						if (e === "")
							return undefined;
						e = "M".concat(e);
						let path = document.createElementNS("http://www.w3.org/2000/svg", 'path');
						path.setAttribute("d", e);
						return path;
					});
					paths.shift(); // First is alwas empty
					paths.forEach((path) => {
						let p = this.svgToPoints([path], xoffset, yoffset);
						if (p?.length) {
							p.forEach((p) => {
								p[1] = -p[1];
								xcoords.push(p[0]);
								ycoords.push(p[1]);
								points.push(p);
							})
							points[points.length - 1][2] = true; // Mark end of line
						}
					});
				}
				xoffset += letters[letter]["width"];
				xcoords = [];
			}
		});
		let result = FillInGaps(points);
		points = Normalize(result, 0.95);
		if (points) {
			this.props.setPointsCallback(points);
			this.props.setMode("view");
		}
	}

	update(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	render() {
		return (
			<span>
				<textarea
					cols={20}
					rows={3}
					name="text"
					onChange={(event) => this.update(event)}
					placeholder="Why not try writing some text"
					defaultValue={this.state?.text}
				/>
				<br />
				<button
					onClick={() => this.use()}
					style={{
						fontSize: "120%",
						borderRadius: "10px"
					}}
					disabled={this.state?.text ? false : true}
				>
					Use text
				</button>
			</span>
		);
	}
}

export default TextWrite;